/** AutoMapa FX / display-currency analytics event names (M17). */
export const FX_CURRENCY_ANALYTICS_EVENTS = Object.freeze({
  CURRENCY_CHANGED: "automap_currency_changed",
  FX_SNAPSHOT_VIEWED: "automap_fx_snapshot_viewed",
});

export const FX_CURRENCY_ANALYTICS_SURFACES = Object.freeze({
  CURRENCY_CHANGE: "currency_change",
  SEARCH_RESULTS: "search_results",
  HOME_INVENTORY: "home_inventory",
  VEHICLE_DETAIL: "vehicle_detail",
  ACCOUNT_FX_HISTORY: "account_fx_history",
  MARKET_INTELLIGENCE: "market_intelligence",
});

export const FX_CURRENCY_SOURCE_COMPONENTS = Object.freeze({
  LOCALE_CONTROLS: "automap_locale_controls",
  ACCOUNT_PREFERENCES_PAGE: "account_preferences_page",
  DEALER_PORTAL_LOCALE_CONTROLS: "dealer_portal_locale_controls",
  FX_NOTICE: "fx_converted_price_notice",
  ACCOUNT_FX_HISTORY: "buyer_account_fx_history",
  MARKET_INTELLIGENCE_FX: "casamapa_market_intelligence_fx",
});
